import { render, staticRenderFns } from "./edit-news.vue?vue&type=template&id=27eefe3e&scoped=true&"
import script from "./edit-news.vue?vue&type=script&lang=js&"
export * from "./edit-news.vue?vue&type=script&lang=js&"
import style0 from "./edit-news.vue?vue&type=style&index=0&id=27eefe3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eefe3e",
  null
  
)

export default component.exports